import styled, { css } from "styled-components";
import { border, buttonBorderRadius, color, onHover, typeStyle, units, variant } from "@m/alchemy-theme";
export const PaginationPage = styled.li `
  border-radius: ${buttonBorderRadius()};
  height: ${({ size }) => (size === "small" ? units(3) : units(4.5))};
  min-width: ${({ size }) => (size === "small" ? units(2) : units(6))};
  padding: ${({ size }) => (size === "small" ? "0" : units(0.25))};
  display: flex;
  align-items: center;
  justify-content: center;

  /* when arrows are shown back to back this will make it look like 1 line in between them */
  margin-left: -1px;

  ${({ arrow }) => arrow &&
    css `
      a,
      button {
        border-radius: ${buttonBorderRadius()};
      }
    `};

  ${({ arrow, hasBorders }) => arrow &&
    hasBorders &&
    css `
      border: ${border()};
      ${variant("arrow", {
        prev: css `
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;

          & a,
          & button {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          }
        `,
        next: css `
          border: ${border()};
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;

          & a,
          & button {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          }
        `
    })};
    `};
`;
export const PaginationPageContent = styled.div `
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${({ size }) => (size === "small" ? units(2.5) : units(4))};
  padding: ${({ size }) => (size === "small" ? `0 ${units(0.25)}` : units(0.75))};
  margin: ${({ size }) => (size === "small" ? units(0.25) : 0)};
  max-width: 100px;
  width: 100%;
  border: none;
  ${typeStyle("bodyS")}
  color: ${color("typeBody")};
  background-color: ${color("container")};
  border-radius: ${buttonBorderRadius()};
  text-decoration: none;
  z-index: 0;
  line-height: 1;

  /* "…" is disabled but needs to be same color as enabled text */
  ${({ isDisabled, value }) => isDisabled &&
    value !== "…" &&
    css `
      color: ${color("highlight")};
    `}

  ${({ isDisabled }) => isDisabled &&
    css `
      cursor: default;
    `}

  ${({ isActive }) => isActive &&
    css `
      ${typeStyle("actionM")}
      background-color: ${color("hint")};
      color: ${color("typeBody")};
      line-height: 1;
    `}

  ${({ isDisabled, isActive }) => !isDisabled &&
    !isActive &&
    onHover(css `
      background-color: ${color("hint", {
        palette: "interactiveNavigational"
    })};
      cursor: pointer;

      z-index: 1;

      &:focus {
        z-index: 2;
      }
    `)}
`;
